import { Splide } from "./vendors/splide.esm";

const handleToggleNavSecond = () => {
    const nav = document.getElementById("jsMenu");
    const hamburger = document.getElementById("jsMenuButton");
    const overlay = document.getElementById("jsHeaderOverlay");

    if (!nav || !hamburger || !overlay) return;

    let isOpen = false;

    const closeMenu = () => {
        nav.style.height = "0";
        hamburger.classList.remove("active");
        overlay.classList.remove("active");
        isOpen = false;
    };

    hamburger.addEventListener("click", (e) => {
        e.stopPropagation();
        isOpen = !isOpen;
        hamburger.classList.toggle("active", isOpen);
        overlay.classList.toggle("active", isOpen);
        nav.style.height = isOpen ? `${nav.scrollHeight}px` : "0";
    });

    document.addEventListener("click", closeMenu);
    nav.addEventListener("click", (e) => {
        e.stopPropagation();
        closeMenu();
    });
};

window.addEventListener("load", () => {
    handleToggleNavSecond();
});

const commonSplideOptions = {
    perPage: 3,
    perMove: 1,
    autoplay: false,
    pagination: true,
    arrows: false,
    gap: 20,
    speed: 800,
    breakpoints: {
        768: {
            type: "loop",
            perPage: 1,
            perMove: 1,
        },
    },
};

const carouselEl = document.getElementById("jsCarouselKatariPoint");

function setupSplide(carouselId, getCondition, onReady) {
    const el = document.getElementById(carouselId);
    if (!el) return null;

    let splide = null;

    function shouldInit() {
        const slideCount = el.querySelectorAll(".splide__slide").length;
        const isSP = window.innerWidth <= 768;
        return getCondition(slideCount, isSP);
    }

    function init() {
        if (!splide && shouldInit()) {
            splide = new Splide(el, commonSplideOptions).mount();

            if (typeof onReady === "function") {
                onReady(splide);
            }
        }
    }

    function destroy() {
        if (splide && !shouldInit()) {
            splide.destroy();
            splide = null;

            if (typeof onReady === "function") {
                onReady(null);
            }
        }
    }

    function update() {
        destroy();
        init();
    }

    update();

    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(update, 200);
    });

    return {
        next: () => splide && splide.go(">"),
        prev: () => splide && splide.go("<"),
        instance: () => splide,
    };
}

const katariPoint = setupSplide("jsCarouselKatariPoint", (count, isSP) =>
    isSP ? count >= 2 : count > 4,
);

const lecturePrevBtn = document.getElementById("jsPrevLectureSplide");
const lectureNextBtn = document.getElementById("jsNextLectureSplide");

function setLectureArrowDisabled(button, isDisabled) {
    if (!button) return;

    button.disabled = isDisabled;
    button.classList.toggle("is-disabled", isDisabled);
    button.setAttribute("aria-disabled", String(isDisabled));
}

function updateLectureArrowState(splide) {
    if (!lecturePrevBtn || !lectureNextBtn) return;

    if (!splide) {
        setLectureArrowDisabled(lecturePrevBtn, true);
        setLectureArrowDisabled(lectureNextBtn, true);
        return;
    }

    const currentIndex = splide.index;
    const lastIndex = splide.Components.Controller.getEnd();

    setLectureArrowDisabled(lecturePrevBtn, currentIndex <= 0);
    setLectureArrowDisabled(lectureNextBtn, currentIndex >= lastIndex);
}

const katariLecture = setupSplide(
    "jsCarouselKatariLecture",
    (count, isSP) => (isSP ? count >= 2 : count > 3),
    (splide) => {
        updateLectureArrowState(splide);

        if (!splide) return;

        splide.on("move moved updated resized refresh", () => {
            updateLectureArrowState(splide);
        });
    },
);

document.getElementById("jsNextLectureSplide")?.addEventListener("click", () => {
    katariLecture?.next();
});

document.getElementById("jsPrevLectureSplide")?.addEventListener("click", () => {
    katariLecture?.prev();
});

document.getElementById("jsNextSplide")?.addEventListener("click", () => {
    katariPoint?.next();
});